import { CSSProperties } from 'react';
import { ISliderIndents } from '../../types';

interface IGetSlidesStyleParams {
  offset: number;
  enableAnimation: boolean;
  animationTime: number;
  indents: ISliderIndents;
}

export function getSlidesStyle(params: IGetSlidesStyleParams): CSSProperties {
  const { animationTime, enableAnimation, indents, offset } = params;
  const { top = 0, left = 0, bottom = 0, right = 0 } = indents;

  return {
    ...(enableAnimation && { transition: `transform ${animationTime}s ease` }),
    transform: `translate3d(${offset}px, 0, 0)`,
    padding: `${top}px ${right}px ${bottom}px ${left}px`,
  };
}
